import styled from 'styled-components';
import { getCDNImageUrl } from '@/helpers/cdn';
import { device, typography } from '@/styles/helpers';

const logo = getCDNImageUrl('/icon-img/logo.svg');

export const ScErrorBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-direction: column;
  align-items: center;
  padding-top: 32px;

  .image {
    margin-top: 44px;
  }

  .buttonWrap {
    display: flex;
    width: 100%;
    max-width: 400px;
    padding: 0 16px;
    justify-content: center;
    column-gap: 8px;
    @media (${device.mobile}) {
      max-width: initial;
    }
    a,
    button {
      font-size: 14px;
      min-width: auto;
      width: 180px;
      button {
        width: 100%;
      }
      @media (${device.mobile}) {
        width: 50%;
      }
    }
  }

  .rich-text {
    text-align: center;
    padding: 0 30px;
    h3 {
      font-weight: bold;
      font-size: 20px;
      line-height: 1.5;
      text-transform: uppercase;
      text-align: center;
    }
    h4 {
      margin-top: 16px;
      opacity: 0.6;
    }
    p {
      margin-top: 8px;
      opacity: 0.6;
      font-size: 0.8em;
    }
    @media (${device.mobile}) {
      h3 {
        font-size: 16px;
      }
      h4 {
        font-size: 0.8em;
      }
      p {
        font-size: 0.7em;
      }
    }
  }

  .url {
    ${typography['caption1regular']}
    color: ${({ theme }) => theme.color2};
    margin-bottom: 32px;
    text-align: center;
  }

  & > img {
    width: 40%;
    height: auto;
    object-fit: contain;
    margin-bottom: 24px;
  }

  & > .logo {
    width: 152px;
    height: 40px;
    background: ${() => `url(${logo}) center no-repeat`};
    @media (${device.mobile}) {
      width: 122px;
      height: 32px;
      margin-bottom: 48px;
    }
  }
  & > p {
    font-weight: bold;
    font-size: 22px;
    line-height: 30px;
    text-transform: uppercase;
    margin-bottom: 8px;
  }
  & > a {
    margin-bottom: 16px;
  }
  @media (${device.tablet}) {
    padding-top: 16px;
    & > p {
      font-size: 20px;
      line-height: 26px;
      width: 90%;
      text-align: center;
    }
    & > img {
      width: 60%;
    }
  }
  @media (${device.mobile}) {
    & > img {
      width: 80%;
    }
  }
`;
